/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiPublicV1StatusGet200Response } from '../models';
// @ts-ignore
import type { ApiV1AnomalyAnomalyIdPhotoPost200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyJoinPost200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyJoinPostRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyPlaceholdersGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyPostRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidAnomaliesGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidAnomaliesPost200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidAnomaliesPostRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidAnomalyPost200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidMultiplayerRotatePost200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidParticipantsGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidPatchRequest } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidPhotoPhotoIdDelete200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidPhotosGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidReopenPost200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidReportGet200Response } from '../models';
// @ts-ignore
import type { ApiV1SurveyUuidWalkPost200Response } from '../models';
// @ts-ignore
import type { StartWalkRequest } from '../models';
/**
 * SurveyApi - axios parameter creator
 */
export const SurveyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of surveys for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of surveys for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyGet_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join (or re-join) a survey by token or code
         * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyJoinPost: async (apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1SurveyJoinPostRequest' is not null or undefined
            assertParamExists('apiV1SurveyJoinPost', 'apiV1SurveyJoinPostRequest', apiV1SurveyJoinPostRequest)
            const localVarPath = `/api/v1/survey/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyJoinPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join (or re-join) a survey by token or code
         * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyJoinPost_2: async (apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiV1SurveyJoinPostRequest' is not null or undefined
            assertParamExists('apiV1SurveyJoinPost_2', 'apiV1SurveyJoinPostRequest', apiV1SurveyJoinPostRequest)
            const localVarPath = `/api/v1/survey/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyJoinPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1SurveyPlaceholdersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey/placeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1SurveyPlaceholdersGet_3: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey/placeholders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new survey
         * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyPost: async (apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new survey
         * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyPost_4: async (apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/survey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey anomalies only
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesGet: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidAnomaliesGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/anomalies`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey anomalies only
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesGet_5: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidAnomaliesGet_5', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/anomalies`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new anomaies for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesPost: async (uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidAnomaliesPost', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/anomalies`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyUuidAnomaliesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new anomaies for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesPost_6: async (uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidAnomaliesPost_6', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/anomalies`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyUuidAnomaliesPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new anomaly for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomalyPost: async (uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidAnomalyPost', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/anomaly`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new anomaly for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomalyPost_7: async (uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidAnomalyPost_7', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/anomaly`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an existing survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidDelete: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidDelete', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an existing survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidDelete_8: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidDelete_8', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportAutocadGet: async (uuid: string, categories?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidExportAutocadGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/export/autocad`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            localVarHeaderParameter['Accept'] = 'text/csv,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportAutocadGet_9: async (uuid: string, categories?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidExportAutocadGet_9', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/export/autocad`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            localVarHeaderParameter['Accept'] = 'text/csv,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a Civil 3D-compatible CSV export of a survey
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportCivil3dGet: async (uuid: string, categories?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidExportCivil3dGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/export/civil3d`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            localVarHeaderParameter['Accept'] = 'text/csv,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a Civil 3D-compatible CSV export of a survey
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportCivil3dGet_10: async (uuid: string, categories?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidExportCivil3dGet_10', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/export/civil3d`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            localVarHeaderParameter['Accept'] = 'text/csv,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey details with walks and anomalies
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidGet: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey details with walks and anomalies
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidGet_11: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidGet_11', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll live participant positions and tracklog increments
         * @param {string} uuid Survey UUID
         * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidLiveGet: async (uuid: string, since?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidLiveGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/live`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poll live participant positions and tracklog increments
         * @param {string} uuid Survey UUID
         * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidLiveGet_12: async (uuid: string, since?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidLiveGet_12', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/live`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerDelete: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidMultiplayerDelete', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/multiplayer`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerDelete_13: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidMultiplayerDelete_13', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/multiplayer`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable multiplayer on a survey (idempotent) and return credentials
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerPost: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidMultiplayerPost', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/multiplayer`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enable multiplayer on a survey (idempotent) and return credentials
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerPost_14: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidMultiplayerPost_14', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/multiplayer`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rotate join credentials, invalidating the old token and code
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerRotatePost: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidMultiplayerRotatePost', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/multiplayer/rotate`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rotate join credentials, invalidating the old token and code
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerRotatePost_15: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidMultiplayerRotatePost_15', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/multiplayer/rotate`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a participant from a survey (master-or-self)
         * @param {string} uuid Survey UUID
         * @param {string} participantUuid Participant UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantParticipantUuidDelete: async (uuid: string, participantUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidParticipantParticipantUuidDelete', 'uuid', uuid)
            // verify required parameter 'participantUuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidParticipantParticipantUuidDelete', 'participantUuid', participantUuid)
            const localVarPath = `/api/v1/survey/{uuid}/participant/{participantUuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)))
                .replace('{participantUuid}', encodeURIComponent(String(participantUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a participant from a survey (master-or-self)
         * @param {string} uuid Survey UUID
         * @param {string} participantUuid Participant UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantParticipantUuidDelete_16: async (uuid: string, participantUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidParticipantParticipantUuidDelete_16', 'uuid', uuid)
            // verify required parameter 'participantUuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidParticipantParticipantUuidDelete_16', 'participantUuid', participantUuid)
            const localVarPath = `/api/v1/survey/{uuid}/participant/{participantUuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)))
                .replace('{participantUuid}', encodeURIComponent(String(participantUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a survey\'s participants with color and role
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantsGet: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidParticipantsGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/participants`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List a survey\'s participants with color and role
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantsGet_17: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidParticipantsGet_17', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/participants`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPatch: async (uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPatch', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyUuidPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPatch_18: async (uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPatch_18', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1SurveyUuidPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a photo from an existing survey
         * @param {string} uuid Survey UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPhotoIdDelete: async (uuid: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPhotoIdDelete', 'uuid', uuid)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPhotoIdDelete', 'photoId', photoId)
            const localVarPath = `/api/v1/survey/{uuid}/photo/{photoId}`
                .replace('{uuid}', encodeURIComponent(String(uuid)))
                .replace('{photoId}', encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a photo from an existing survey
         * @param {string} uuid Survey UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPhotoIdDelete_19: async (uuid: string, photoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPhotoIdDelete_19', 'uuid', uuid)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPhotoIdDelete_19', 'photoId', photoId)
            const localVarPath = `/api/v1/survey/{uuid}/photo/{photoId}`
                .replace('{uuid}', encodeURIComponent(String(uuid)))
                .replace('{photoId}', encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a photo to an existing survey
         * @param {string} uuid Survey UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
         * @param {string} [latitude] GPS latitude for a single photo upload (optional)
         * @param {string} [longitude] GPS longitude for a single photo upload (optional)
         * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
         * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
         * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPost: async (uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPost', 'uuid', uuid)
            // verify required parameter 'photos' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPost', 'photos', photos)
            const localVarPath = `/api/v1/survey/{uuid}/photo`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (photos) {
                photos.forEach((element) => {
                    localVarFormParams.append('photos[]', element as any);
                })
            }


            if (latitude !== undefined) { 
                localVarFormParams.append('latitude', latitude as any);
            }

            if (longitude !== undefined) { 
                localVarFormParams.append('longitude', longitude as any);
            }

            if (accuracy !== undefined) { 
                localVarFormParams.append('accuracy', accuracy as any);
            }
            if (latitude2) {
                latitude2.forEach((element) => {
                    localVarFormParams.append('latitude[]', element as any);
                })
            }

            if (longitude2) {
                longitude2.forEach((element) => {
                    localVarFormParams.append('longitude[]', element as any);
                })
            }

            if (accuracy2) {
                accuracy2.forEach((element) => {
                    localVarFormParams.append('accuracy[]', element as any);
                })
            }


            if (heading !== undefined) { 
                localVarFormParams.append('heading', heading as any);
            }
            if (heading2) {
                localVarFormParams.append('heading[]', heading2.join(COLLECTION_FORMATS.csv));
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a photo to an existing survey
         * @param {string} uuid Survey UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
         * @param {string} [latitude] GPS latitude for a single photo upload (optional)
         * @param {string} [longitude] GPS longitude for a single photo upload (optional)
         * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
         * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
         * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPost_20: async (uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPost_20', 'uuid', uuid)
            // verify required parameter 'photos' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotoPost_20', 'photos', photos)
            const localVarPath = `/api/v1/survey/{uuid}/photo`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (photos) {
                photos.forEach((element) => {
                    localVarFormParams.append('photos[]', element as any);
                })
            }


            if (latitude !== undefined) { 
                localVarFormParams.append('latitude', latitude as any);
            }

            if (longitude !== undefined) { 
                localVarFormParams.append('longitude', longitude as any);
            }

            if (accuracy !== undefined) { 
                localVarFormParams.append('accuracy', accuracy as any);
            }
            if (latitude2) {
                latitude2.forEach((element) => {
                    localVarFormParams.append('latitude[]', element as any);
                })
            }

            if (longitude2) {
                longitude2.forEach((element) => {
                    localVarFormParams.append('longitude[]', element as any);
                })
            }

            if (accuracy2) {
                accuracy2.forEach((element) => {
                    localVarFormParams.append('accuracy[]', element as any);
                })
            }


            if (heading !== undefined) { 
                localVarFormParams.append('heading', heading as any);
            }
            if (heading2) {
                localVarFormParams.append('heading[]', heading2.join(COLLECTION_FORMATS.csv));
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of photos for a survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotosGet: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotosGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/photos`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of photos for a survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotosGet_21: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidPhotosGet_21', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/photos`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reopen a finished survey (master only)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReopenPost: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidReopenPost', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/reopen`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reopen a finished survey (master only)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReopenPost_22: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidReopenPost_22', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/reopen`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get rhe survey report in PDF format
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReportGet: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidReportGet', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/report`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get rhe survey report in PDF format
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReportGet_23: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidReportGet_23', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/report`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new walk for a survey
         * @param {string} uuid Survey UUID
         * @param {StartWalkRequest} [startWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidWalkPost: async (uuid: string, startWalkRequest?: StartWalkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidWalkPost', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/walk`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startWalkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new walk for a survey
         * @param {string} uuid Survey UUID
         * @param {StartWalkRequest} [startWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidWalkPost_24: async (uuid: string, startWalkRequest?: StartWalkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiV1SurveyUuidWalkPost_24', 'uuid', uuid)
            const localVarPath = `/api/v1/survey/{uuid}/walk`
                .replace('{uuid}', encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startWalkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyApi - functional programming interface
 */
export const SurveyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of surveys for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of surveys for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyGet_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyGet_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Join (or re-join) a survey by token or code
         * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyJoinPost(apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyJoinPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyJoinPost(apiV1SurveyJoinPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyJoinPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Join (or re-join) a survey by token or code
         * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyJoinPost_2(apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyJoinPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyJoinPost_2(apiV1SurveyJoinPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyJoinPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiV1SurveyPlaceholdersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyPlaceholdersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyPlaceholdersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyPlaceholdersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async apiV1SurveyPlaceholdersGet_3(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyPlaceholdersGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyPlaceholdersGet_3(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyPlaceholdersGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new survey
         * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyPost(apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReopenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyPost(apiV1SurveyPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new survey
         * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyPost_4(apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReopenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyPost_4(apiV1SurveyPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyPost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey anomalies only
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidAnomaliesGet(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidAnomaliesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidAnomaliesGet(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidAnomaliesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey anomalies only
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidAnomaliesGet_5(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidAnomaliesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidAnomaliesGet_5(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidAnomaliesGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new anomaies for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidAnomaliesPost(uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidAnomaliesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidAnomaliesPost(uuid, apiV1SurveyUuidAnomaliesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidAnomaliesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new anomaies for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidAnomaliesPost_6(uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidAnomaliesPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidAnomaliesPost_6(uuid, apiV1SurveyUuidAnomaliesPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidAnomaliesPost_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new anomaly for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidAnomalyPost(uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidAnomalyPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidAnomalyPost(uuid, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidAnomalyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new anomaly for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidAnomalyPost_7(uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidAnomalyPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidAnomalyPost_7(uuid, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidAnomalyPost_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an existing survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidDelete(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidDelete(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an existing survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidDelete_8(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidDelete_8(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidDelete_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidExportAutocadGet(uuid: string, categories?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidExportAutocadGet(uuid, categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidExportAutocadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidExportAutocadGet_9(uuid: string, categories?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidExportAutocadGet_9(uuid, categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidExportAutocadGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a Civil 3D-compatible CSV export of a survey
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidExportCivil3dGet(uuid: string, categories?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidExportCivil3dGet(uuid, categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidExportCivil3dGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a Civil 3D-compatible CSV export of a survey
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidExportCivil3dGet_10(uuid: string, categories?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidExportCivil3dGet_10(uuid, categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidExportCivil3dGet_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey details with walks and anomalies
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidGet(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidGet(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey details with walks and anomalies
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidGet_11(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidGet_11(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidGet_11']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poll live participant positions and tracklog increments
         * @param {string} uuid Survey UUID
         * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidLiveGet(uuid: string, since?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidLiveGet(uuid, since, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poll live participant positions and tracklog increments
         * @param {string} uuid Survey UUID
         * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidLiveGet_12(uuid: string, since?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidLiveGet_12(uuid, since, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidLiveGet_12']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidMultiplayerDelete(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPublicV1StatusGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidMultiplayerDelete(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidMultiplayerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidMultiplayerDelete_13(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPublicV1StatusGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidMultiplayerDelete_13(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidMultiplayerDelete_13']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable multiplayer on a survey (idempotent) and return credentials
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidMultiplayerPost(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidMultiplayerPost(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidMultiplayerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Enable multiplayer on a survey (idempotent) and return credentials
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidMultiplayerPost_14(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidMultiplayerPost_14(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidMultiplayerPost_14']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rotate join credentials, invalidating the old token and code
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidMultiplayerRotatePost(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidMultiplayerRotatePost(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidMultiplayerRotatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Rotate join credentials, invalidating the old token and code
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidMultiplayerRotatePost_15(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidMultiplayerRotatePost_15(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidMultiplayerRotatePost_15']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a participant from a survey (master-or-self)
         * @param {string} uuid Survey UUID
         * @param {string} participantUuid Participant UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidParticipantParticipantUuidDelete(uuid: string, participantUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPublicV1StatusGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidParticipantParticipantUuidDelete(uuid, participantUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidParticipantParticipantUuidDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a participant from a survey (master-or-self)
         * @param {string} uuid Survey UUID
         * @param {string} participantUuid Participant UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidParticipantParticipantUuidDelete_16(uuid: string, participantUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPublicV1StatusGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidParticipantParticipantUuidDelete_16(uuid, participantUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidParticipantParticipantUuidDelete_16']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a survey\'s participants with color and role
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidParticipantsGet(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidParticipantsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidParticipantsGet(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidParticipantsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List a survey\'s participants with color and role
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidParticipantsGet_17(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidParticipantsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidParticipantsGet_17(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidParticipantsGet_17']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPatch(uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReopenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPatch(uuid, apiV1SurveyUuidPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPatch_18(uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReopenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPatch_18(uuid, apiV1SurveyUuidPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPatch_18']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a photo from an existing survey
         * @param {string} uuid Survey UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPhotoPhotoIdDelete(uuid: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidPhotoPhotoIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPhotoPhotoIdDelete(uuid, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPhotoPhotoIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a photo from an existing survey
         * @param {string} uuid Survey UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPhotoPhotoIdDelete_19(uuid: string, photoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidPhotoPhotoIdDelete200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPhotoPhotoIdDelete_19(uuid, photoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPhotoPhotoIdDelete_19']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a photo to an existing survey
         * @param {string} uuid Survey UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
         * @param {string} [latitude] GPS latitude for a single photo upload (optional)
         * @param {string} [longitude] GPS longitude for a single photo upload (optional)
         * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
         * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
         * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPhotoPost(uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPhotoPost(uuid, photos, latitude, longitude, accuracy, latitude2, longitude2, accuracy2, heading, heading2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPhotoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a photo to an existing survey
         * @param {string} uuid Survey UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
         * @param {string} [latitude] GPS latitude for a single photo upload (optional)
         * @param {string} [longitude] GPS longitude for a single photo upload (optional)
         * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
         * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
         * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPhotoPost_20(uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPhotoPost_20(uuid, photos, latitude, longitude, accuracy, latitude2, longitude2, accuracy2, heading, heading2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPhotoPost_20']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of photos for a survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPhotosGet(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidPhotosGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPhotosGet(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPhotosGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of photos for a survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidPhotosGet_21(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidPhotosGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidPhotosGet_21(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidPhotosGet_21']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reopen a finished survey (master only)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidReopenPost(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReopenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidReopenPost(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidReopenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reopen a finished survey (master only)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidReopenPost_22(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReopenPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidReopenPost_22(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidReopenPost_22']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get rhe survey report in PDF format
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidReportGet(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReportGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidReportGet(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidReportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get rhe survey report in PDF format
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidReportGet_23(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidReportGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidReportGet_23(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidReportGet_23']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new walk for a survey
         * @param {string} uuid Survey UUID
         * @param {StartWalkRequest} [startWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidWalkPost(uuid: string, startWalkRequest?: StartWalkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidWalkPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidWalkPost(uuid, startWalkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidWalkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new walk for a survey
         * @param {string} uuid Survey UUID
         * @param {StartWalkRequest} [startWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1SurveyUuidWalkPost_24(uuid: string, startWalkRequest?: StartWalkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidWalkPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1SurveyUuidWalkPost_24(uuid, startWalkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyApi.apiV1SurveyUuidWalkPost_24']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyApi - factory interface
 */
export const SurveyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of surveys for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyGet200Response> {
            return localVarFp.apiV1SurveyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of surveys for the authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyGet_1(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyGet200Response> {
            return localVarFp.apiV1SurveyGet_1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join (or re-join) a survey by token or code
         * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyJoinPost(apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyJoinPost200Response> {
            return localVarFp.apiV1SurveyJoinPost(apiV1SurveyJoinPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join (or re-join) a survey by token or code
         * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyJoinPost_2(apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyJoinPost200Response> {
            return localVarFp.apiV1SurveyJoinPost_2(apiV1SurveyJoinPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1SurveyPlaceholdersGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyPlaceholdersGet200Response> {
            return localVarFp.apiV1SurveyPlaceholdersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        apiV1SurveyPlaceholdersGet_3(options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyPlaceholdersGet200Response> {
            return localVarFp.apiV1SurveyPlaceholdersGet_3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new survey
         * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyPost(apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReopenPost200Response> {
            return localVarFp.apiV1SurveyPost(apiV1SurveyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new survey
         * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyPost_4(apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReopenPost200Response> {
            return localVarFp.apiV1SurveyPost_4(apiV1SurveyPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey anomalies only
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesGet(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidAnomaliesGet200Response> {
            return localVarFp.apiV1SurveyUuidAnomaliesGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey anomalies only
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesGet_5(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidAnomaliesGet200Response> {
            return localVarFp.apiV1SurveyUuidAnomaliesGet_5(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new anomaies for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesPost(uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidAnomaliesPost200Response> {
            return localVarFp.apiV1SurveyUuidAnomaliesPost(uuid, apiV1SurveyUuidAnomaliesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new anomaies for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomaliesPost_6(uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidAnomaliesPost200Response> {
            return localVarFp.apiV1SurveyUuidAnomaliesPost_6(uuid, apiV1SurveyUuidAnomaliesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new anomaly for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomalyPost(uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidAnomalyPost200Response> {
            return localVarFp.apiV1SurveyUuidAnomalyPost(uuid, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new anomaly for a survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidAnomalyPost_7(uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidAnomalyPost200Response> {
            return localVarFp.apiV1SurveyUuidAnomalyPost_7(uuid, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an existing survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidDelete(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidDelete200Response> {
            return localVarFp.apiV1SurveyUuidDelete(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an existing survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidDelete_8(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidDelete200Response> {
            return localVarFp.apiV1SurveyUuidDelete_8(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportAutocadGet(uuid: string, categories?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1SurveyUuidExportAutocadGet(uuid, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportAutocadGet_9(uuid: string, categories?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1SurveyUuidExportAutocadGet_9(uuid, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a Civil 3D-compatible CSV export of a survey
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportCivil3dGet(uuid: string, categories?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1SurveyUuidExportCivil3dGet(uuid, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a Civil 3D-compatible CSV export of a survey
         * @param {string} uuid Survey UUID
         * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidExportCivil3dGet_10(uuid: string, categories?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiV1SurveyUuidExportCivil3dGet_10(uuid, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey details with walks and anomalies
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidGet(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidGet200Response> {
            return localVarFp.apiV1SurveyUuidGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey details with walks and anomalies
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidGet_11(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidGet200Response> {
            return localVarFp.apiV1SurveyUuidGet_11(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll live participant positions and tracklog increments
         * @param {string} uuid Survey UUID
         * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidLiveGet(uuid: string, since?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidLiveGet200Response> {
            return localVarFp.apiV1SurveyUuidLiveGet(uuid, since, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poll live participant positions and tracklog increments
         * @param {string} uuid Survey UUID
         * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidLiveGet_12(uuid: string, since?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidLiveGet200Response> {
            return localVarFp.apiV1SurveyUuidLiveGet_12(uuid, since, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerDelete(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiPublicV1StatusGet200Response> {
            return localVarFp.apiV1SurveyUuidMultiplayerDelete(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerDelete_13(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiPublicV1StatusGet200Response> {
            return localVarFp.apiV1SurveyUuidMultiplayerDelete_13(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable multiplayer on a survey (idempotent) and return credentials
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerPost(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response> {
            return localVarFp.apiV1SurveyUuidMultiplayerPost(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enable multiplayer on a survey (idempotent) and return credentials
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerPost_14(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response> {
            return localVarFp.apiV1SurveyUuidMultiplayerPost_14(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rotate join credentials, invalidating the old token and code
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerRotatePost(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response> {
            return localVarFp.apiV1SurveyUuidMultiplayerRotatePost(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rotate join credentials, invalidating the old token and code
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidMultiplayerRotatePost_15(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidMultiplayerRotatePost200Response> {
            return localVarFp.apiV1SurveyUuidMultiplayerRotatePost_15(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a participant from a survey (master-or-self)
         * @param {string} uuid Survey UUID
         * @param {string} participantUuid Participant UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantParticipantUuidDelete(uuid: string, participantUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiPublicV1StatusGet200Response> {
            return localVarFp.apiV1SurveyUuidParticipantParticipantUuidDelete(uuid, participantUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a participant from a survey (master-or-self)
         * @param {string} uuid Survey UUID
         * @param {string} participantUuid Participant UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantParticipantUuidDelete_16(uuid: string, participantUuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiPublicV1StatusGet200Response> {
            return localVarFp.apiV1SurveyUuidParticipantParticipantUuidDelete_16(uuid, participantUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a survey\'s participants with color and role
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantsGet(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidParticipantsGet200Response> {
            return localVarFp.apiV1SurveyUuidParticipantsGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List a survey\'s participants with color and role
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidParticipantsGet_17(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidParticipantsGet200Response> {
            return localVarFp.apiV1SurveyUuidParticipantsGet_17(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPatch(uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReopenPost200Response> {
            return localVarFp.apiV1SurveyUuidPatch(uuid, apiV1SurveyUuidPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing survey
         * @param {string} uuid Survey UUID
         * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPatch_18(uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReopenPost200Response> {
            return localVarFp.apiV1SurveyUuidPatch_18(uuid, apiV1SurveyUuidPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a photo from an existing survey
         * @param {string} uuid Survey UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPhotoIdDelete(uuid: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidPhotoPhotoIdDelete200Response> {
            return localVarFp.apiV1SurveyUuidPhotoPhotoIdDelete(uuid, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a photo from an existing survey
         * @param {string} uuid Survey UUID
         * @param {string} photoId Photo UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPhotoIdDelete_19(uuid: string, photoId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidPhotoPhotoIdDelete200Response> {
            return localVarFp.apiV1SurveyUuidPhotoPhotoIdDelete_19(uuid, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a photo to an existing survey
         * @param {string} uuid Survey UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
         * @param {string} [latitude] GPS latitude for a single photo upload (optional)
         * @param {string} [longitude] GPS longitude for a single photo upload (optional)
         * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
         * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
         * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPost(uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response> {
            return localVarFp.apiV1SurveyUuidPhotoPost(uuid, photos, latitude, longitude, accuracy, latitude2, longitude2, accuracy2, heading, heading2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a photo to an existing survey
         * @param {string} uuid Survey UUID
         * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
         * @param {string} [latitude] GPS latitude for a single photo upload (optional)
         * @param {string} [longitude] GPS longitude for a single photo upload (optional)
         * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
         * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
         * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotoPost_20(uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1AnomalyAnomalyIdPhotoPost200Response> {
            return localVarFp.apiV1SurveyUuidPhotoPost_20(uuid, photos, latitude, longitude, accuracy, latitude2, longitude2, accuracy2, heading, heading2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of photos for a survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotosGet(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidPhotosGet200Response> {
            return localVarFp.apiV1SurveyUuidPhotosGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of photos for a survey
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidPhotosGet_21(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidPhotosGet200Response> {
            return localVarFp.apiV1SurveyUuidPhotosGet_21(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reopen a finished survey (master only)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReopenPost(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReopenPost200Response> {
            return localVarFp.apiV1SurveyUuidReopenPost(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reopen a finished survey (master only)
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReopenPost_22(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReopenPost200Response> {
            return localVarFp.apiV1SurveyUuidReopenPost_22(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get rhe survey report in PDF format
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReportGet(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReportGet200Response> {
            return localVarFp.apiV1SurveyUuidReportGet(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get rhe survey report in PDF format
         * @param {string} uuid Survey UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidReportGet_23(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidReportGet200Response> {
            return localVarFp.apiV1SurveyUuidReportGet_23(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new walk for a survey
         * @param {string} uuid Survey UUID
         * @param {StartWalkRequest} [startWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidWalkPost(uuid: string, startWalkRequest?: StartWalkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidWalkPost200Response> {
            return localVarFp.apiV1SurveyUuidWalkPost(uuid, startWalkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new walk for a survey
         * @param {string} uuid Survey UUID
         * @param {StartWalkRequest} [startWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1SurveyUuidWalkPost_24(uuid: string, startWalkRequest?: StartWalkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidWalkPost200Response> {
            return localVarFp.apiV1SurveyUuidWalkPost_24(uuid, startWalkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SurveyApi - object-oriented interface
 */
export class SurveyApi extends BaseAPI {
    /**
     * 
     * @summary Get list of surveys for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyGet(options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of surveys for the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyGet_1(options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyGet_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join (or re-join) a survey by token or code
     * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyJoinPost(apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyJoinPost(apiV1SurveyJoinPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join (or re-join) a survey by token or code
     * @param {ApiV1SurveyJoinPostRequest} apiV1SurveyJoinPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyJoinPost_2(apiV1SurveyJoinPostRequest: ApiV1SurveyJoinPostRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyJoinPost_2(apiV1SurveyJoinPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiV1SurveyPlaceholdersGet(options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyPlaceholdersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Get available placeholders for PDF report templates — use GET /system-config instead
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    public apiV1SurveyPlaceholdersGet_3(options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyPlaceholdersGet_3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new survey
     * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyPost(apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyPost(apiV1SurveyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new survey
     * @param {ApiV1SurveyPostRequest} [apiV1SurveyPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyPost_4(apiV1SurveyPostRequest?: ApiV1SurveyPostRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyPost_4(apiV1SurveyPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey anomalies only
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidAnomaliesGet(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidAnomaliesGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey anomalies only
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidAnomaliesGet_5(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidAnomaliesGet_5(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new anomaies for a survey
     * @param {string} uuid Survey UUID
     * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidAnomaliesPost(uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidAnomaliesPost(uuid, apiV1SurveyUuidAnomaliesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new anomaies for a survey
     * @param {string} uuid Survey UUID
     * @param {ApiV1SurveyUuidAnomaliesPostRequest} [apiV1SurveyUuidAnomaliesPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidAnomaliesPost_6(uuid: string, apiV1SurveyUuidAnomaliesPostRequest?: ApiV1SurveyUuidAnomaliesPostRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidAnomaliesPost_6(uuid, apiV1SurveyUuidAnomaliesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new anomaly for a survey
     * @param {string} uuid Survey UUID
     * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidAnomalyPost(uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidAnomalyPost(uuid, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new anomaly for a survey
     * @param {string} uuid Survey UUID
     * @param {ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner} [apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidAnomalyPost_7(uuid: string, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner?: ApiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidAnomalyPost_7(uuid, apiV1SurveyUuidAnomaliesPostRequestAnomaliesInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an existing survey
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidDelete(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidDelete(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an existing survey
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidDelete_8(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidDelete_8(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
     * @param {string} uuid Survey UUID
     * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidExportAutocadGet(uuid: string, categories?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidExportAutocadGet(uuid, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download an AutoCAD Civil 3D PENZD CSV export of a survey with UTM Easting/Northing coordinates
     * @param {string} uuid Survey UUID
     * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidExportAutocadGet_9(uuid: string, categories?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidExportAutocadGet_9(uuid, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a Civil 3D-compatible CSV export of a survey
     * @param {string} uuid Survey UUID
     * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidExportCivil3dGet(uuid: string, categories?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidExportCivil3dGet(uuid, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a Civil 3D-compatible CSV export of a survey
     * @param {string} uuid Survey UUID
     * @param {string} [categories] Comma-separated list of categories to include. Omit for all; empty value for none. Valid values: leaks, boundaries, tracklog.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidExportCivil3dGet_10(uuid: string, categories?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidExportCivil3dGet_10(uuid, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey details with walks and anomalies
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidGet(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey details with walks and anomalies
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidGet_11(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidGet_11(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll live participant positions and tracklog increments
     * @param {string} uuid Survey UUID
     * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidLiveGet(uuid: string, since?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidLiveGet(uuid, since, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poll live participant positions and tracklog increments
     * @param {string} uuid Survey UUID
     * @param {string} [since] ISO-8601 cursor (echoed serverTime from a previous call). Omit for a full initial load, capped per participant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidLiveGet_12(uuid: string, since?: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidLiveGet_12(uuid, since, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidMultiplayerDelete(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidMultiplayerDelete(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disable multiplayer on a survey (credentials are preserved, not returned)
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidMultiplayerDelete_13(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidMultiplayerDelete_13(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable multiplayer on a survey (idempotent) and return credentials
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidMultiplayerPost(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidMultiplayerPost(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enable multiplayer on a survey (idempotent) and return credentials
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidMultiplayerPost_14(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidMultiplayerPost_14(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rotate join credentials, invalidating the old token and code
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidMultiplayerRotatePost(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidMultiplayerRotatePost(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rotate join credentials, invalidating the old token and code
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidMultiplayerRotatePost_15(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidMultiplayerRotatePost_15(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a participant from a survey (master-or-self)
     * @param {string} uuid Survey UUID
     * @param {string} participantUuid Participant UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidParticipantParticipantUuidDelete(uuid: string, participantUuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidParticipantParticipantUuidDelete(uuid, participantUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a participant from a survey (master-or-self)
     * @param {string} uuid Survey UUID
     * @param {string} participantUuid Participant UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidParticipantParticipantUuidDelete_16(uuid: string, participantUuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidParticipantParticipantUuidDelete_16(uuid, participantUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a survey\'s participants with color and role
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidParticipantsGet(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidParticipantsGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List a survey\'s participants with color and role
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidParticipantsGet_17(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidParticipantsGet_17(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing survey
     * @param {string} uuid Survey UUID
     * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPatch(uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPatch(uuid, apiV1SurveyUuidPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing survey
     * @param {string} uuid Survey UUID
     * @param {ApiV1SurveyUuidPatchRequest} [apiV1SurveyUuidPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPatch_18(uuid: string, apiV1SurveyUuidPatchRequest?: ApiV1SurveyUuidPatchRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPatch_18(uuid, apiV1SurveyUuidPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a photo from an existing survey
     * @param {string} uuid Survey UUID
     * @param {string} photoId Photo UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPhotoPhotoIdDelete(uuid: string, photoId: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPhotoPhotoIdDelete(uuid, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a photo from an existing survey
     * @param {string} uuid Survey UUID
     * @param {string} photoId Photo UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPhotoPhotoIdDelete_19(uuid: string, photoId: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPhotoPhotoIdDelete_19(uuid, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a photo to an existing survey
     * @param {string} uuid Survey UUID
     * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
     * @param {string} [latitude] GPS latitude for a single photo upload (optional)
     * @param {string} [longitude] GPS longitude for a single photo upload (optional)
     * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
     * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
     * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPhotoPost(uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPhotoPost(uuid, photos, latitude, longitude, accuracy, latitude2, longitude2, accuracy2, heading, heading2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a photo to an existing survey
     * @param {string} uuid Survey UUID
     * @param {Array<File>} photos Photo files (JPEG, PNG, GIF, WebP) - use photos[] as field name for multiple files
     * @param {string} [latitude] GPS latitude for a single photo upload (optional)
     * @param {string} [longitude] GPS longitude for a single photo upload (optional)
     * @param {number} [accuracy] GPS accuracy in meters for a single photo upload (optional)
     * @param {Array<string | null>} [latitude2] Per-photo GPS latitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {Array<string | null>} [longitude2] Per-photo GPS longitude array for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {Array<number | null>} [accuracy2] Per-photo GPS accuracy array (meters) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {number} [heading] GPS heading in degrees for a single photo upload (optional)
     * @param {Array<number | null>} [heading2] Per-photo GPS heading array (degrees) for multi-file uploads, indexed to match photos[] order (optional). Individual elements may be null when a photo has no GPS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPhotoPost_20(uuid: string, photos: Array<File>, latitude?: string, longitude?: string, accuracy?: number, latitude2?: Array<string | null>, longitude2?: Array<string | null>, accuracy2?: Array<number | null>, heading?: number, heading2?: Array<number | null>, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPhotoPost_20(uuid, photos, latitude, longitude, accuracy, latitude2, longitude2, accuracy2, heading, heading2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of photos for a survey
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPhotosGet(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPhotosGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of photos for a survey
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidPhotosGet_21(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidPhotosGet_21(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reopen a finished survey (master only)
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidReopenPost(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidReopenPost(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reopen a finished survey (master only)
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidReopenPost_22(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidReopenPost_22(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get rhe survey report in PDF format
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidReportGet(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidReportGet(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get rhe survey report in PDF format
     * @param {string} uuid Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidReportGet_23(uuid: string, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidReportGet_23(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new walk for a survey
     * @param {string} uuid Survey UUID
     * @param {StartWalkRequest} [startWalkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidWalkPost(uuid: string, startWalkRequest?: StartWalkRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidWalkPost(uuid, startWalkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new walk for a survey
     * @param {string} uuid Survey UUID
     * @param {StartWalkRequest} [startWalkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1SurveyUuidWalkPost_24(uuid: string, startWalkRequest?: StartWalkRequest, options?: RawAxiosRequestConfig) {
        return SurveyApiFp(this.configuration).apiV1SurveyUuidWalkPost_24(uuid, startWalkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

